import {Box, InputText as RawInput, Label, Span} from 'exsportia-components'
import {useFormikContext} from 'formik'
import {ChangeEvent, FC, PropsWithChildren, useCallback, useState} from 'react'

type Props = {
  id: string
  disabled?: boolean
  placeholder?: string
  label?: string
  required?: boolean
  type?: string
  uppercase?: boolean
  value?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

export const Input: FC<PropsWithChildren<Props>> = ({
  disabled = false,
  id,
  placeholder,
  required = false,
  label,
  type,
  uppercase = false,
  value: externalValue,
  onChange: externalOnChange,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false)
  const formik = useFormikContext<any>()
  const values = formik?.values || {}
  const errors = formik?.errors || {}
  const setFieldValue = formik?.setFieldValue

  const value = externalValue ?? values[id]
  const error = errors[id] as string

  const paswordTypeSettings =
    type === 'password'
      ? {
          icon: isPasswordVisible ? 'hide' : 'view',
          onIconClick: () => setIsPasswordVisible(!isPasswordVisible),
        }
      : {}
  const typeToUse = type === 'password' ? (isPasswordVisible ? 'text' : 'password') : type

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (externalOnChange) {
        externalOnChange(e)
      } else if (setFieldValue) {
        setFieldValue(id, uppercase ? e.target.value.toUpperCase() : e.target.value)
      }
    },
    [id, setFieldValue, uppercase, externalOnChange],
  )

  return (
    <>
      {label && (
        <Label settings={{color: error ? 'error' : 'text-secondary'}}>
          {label}
          {required && <Span color={'error'}>*</Span>}
        </Label>
      )}
      <RawInput
        // @ts-ignore
        onChange={handleChange}
        name={id}
        id={id}
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        error={error}
        type={typeToUse}
        settings={{
          // fontSize: '16px'
        }}
        {...paswordTypeSettings}
      />
      {error && (
        <Box
          mt='5px'
          mb='10px'
          fontSize='12px'
          color='error'
        >
          {error}
        </Box>
      )}
    </>
  )
}
